import React from 'react';
import {
  RIGHT_PANEL_TAB_CATEGORY_SPEND,
  RIGHT_PANEL_TAB_FINANCIAL,
  RIGHT_PANEL_TAB_LABELS,
  RIGHT_PANEL_TAB_NUTRITION,
  RIGHT_PANEL_TAB_QUANTITY,
} from 'constants/uiConstants';
import { RightPanelTabId } from '../../redux/slices/InsightsSlice';
import CategorySpendPanel from './panels/CategorySpendPanel';
import FinancialRiskPanel from './panels/FinancialRiskPanel';
import NutritionTallyPanel from './panels/NutritionTallyPanel';
import QuantityRequiredPanel from './panels/QuantityRequiredPanel';

interface RightPanelTabRouterProps {
  tabId: RightPanelTabId;
}

/**
 * Routes a RightPanelTabId to its content component.
 */
const RightPanelTabRouter: React.FC<RightPanelTabRouterProps> = ({ tabId }) => {
  if (tabId === RIGHT_PANEL_TAB_NUTRITION) {
    return <NutritionTallyPanel />;
  }

  if (tabId === RIGHT_PANEL_TAB_FINANCIAL) {
    return <FinancialRiskPanel />;
  }

  if (tabId === RIGHT_PANEL_TAB_CATEGORY_SPEND) {
    return <CategorySpendPanel />;
  }

  if (tabId === RIGHT_PANEL_TAB_QUANTITY) {
    return <QuantityRequiredPanel />;
  }

  return (
    <p className="text-xs text-gray-muted">
      {RIGHT_PANEL_TAB_LABELS[tabId]} — coming soon
    </p>
  );
};

export default RightPanelTabRouter;
